/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/*
  LucaTech3D Anpassung:
  Shopify Cookie-Banner automatisch anzeigen,
  wenn noch keine Cookie-Auswahl getroffen wurde.
  Zusätzlich Footer-Link "Cookie-Einstellungen" erneut öffnen.
*/

(function () {
  function loadShopifyCustomerPrivacy(callback) {
    if (!window.Shopify) {
      callback(false);
      return;
    }

    if (window.Shopify.customerPrivacy) {
      callback(true);
      return;
    }

    if (typeof window.Shopify.loadFeatures !== "function") {
      callback(false);
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1"
        }
      ],
      function (error) {
        if (error) {
          callback(false);
          return;
        }

        callback(Boolean(window.Shopify.customerPrivacy));
      }
    );
  }

  function getTrackingConsentStatus() {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.getTrackingConsent === "function"
    ) {
      return window.Shopify.customerPrivacy.getTrackingConsent();
    }

    return null;
  }

  function showShopifyCookieBanner() {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showBanner === "function"
    ) {
      window.Shopify.customerPrivacy.showBanner();
      return true;
    }

    return false;
  }

  function showShopifyCookiePreferences() {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === "function"
    ) {
      window.Shopify.customerPrivacy.showPreferences();
      return true;
    }

    if (showShopifyCookieBanner()) {
      return true;
    }

    return false;
  }

  function autoShowCookieBannerIfNeeded() {
    loadShopifyCustomerPrivacy(function (loaded) {
      if (!loaded) {
        console.warn("Shopify Customer Privacy API konnte nicht geladen werden.");
        return;
      }

      var trackingConsentStatus = getTrackingConsentStatus();

      if (
        trackingConsentStatus === "no_interaction" ||
        trackingConsentStatus === "" ||
        trackingConsentStatus === null ||
        typeof trackingConsentStatus === "undefined"
      ) {
        showShopifyCookieBanner();
      }
    });
  }

  window.reopenConsent = function () {
    loadShopifyCustomerPrivacy(function (loaded) {
      if (!loaded) {
        console.warn("Shopify Customer Privacy API konnte nicht geladen werden.");
        return;
      }

      if (!showShopifyCookiePreferences()) {
        console.warn("Cookie-Einstellungen konnten nicht erneut geöffnet werden.");
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(autoShowCookieBannerIfNeeded, 500);
  });

  window.addEventListener("load", function () {
    setTimeout(autoShowCookieBannerIfNeeded, 1000);
  });
})();

/*
  LucaTech3D Anpassung:
  Judge.me Bewertung in Produktkarten kürzen.
  Aus "7 reviews" wird nur "7".
  Ohne dauerhaften MutationObserver, damit die Seite nicht hängt.
*/

(function () {
  function cleanProductCardJudgeMeText() {
    var badges = document.querySelectorAll(".product-card__judgeme-badge .jdgm-prev-badge");

    badges.forEach(function (badge) {
      var textElement = badge.querySelector(".jdgm-prev-badge__text");

      if (!textElement) {
        return;
      }

      if (textElement.dataset.lucatechCleaned === "true") {
        return;
      }

      var countFromAttribute =
        badge.getAttribute("data-number-of-reviews") ||
        badge.dataset.numberOfReviews ||
        "";

      var rawText = textElement.textContent.trim();
      var countFromText = rawText.match(/\d+/);
      var reviewCount = countFromAttribute || (countFromText ? countFromText[0] : "");

      if (!reviewCount) {
        return;
      }

      textElement.textContent = reviewCount;
      textElement.setAttribute("aria-label", reviewCount);
      textElement.dataset.lucatechCleaned = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    cleanProductCardJudgeMeText();

    setTimeout(cleanProductCardJudgeMeText, 300);
    setTimeout(cleanProductCardJudgeMeText, 800);
    setTimeout(cleanProductCardJudgeMeText, 1500);
    setTimeout(cleanProductCardJudgeMeText, 2500);
  });

  window.addEventListener("load", function () {
    cleanProductCardJudgeMeText();

    setTimeout(cleanProductCardJudgeMeText, 500);
    setTimeout(cleanProductCardJudgeMeText, 1500);
  });
})();